<template>
  <!-- <ClipLoader :color="themeColors()" :size="`${size}px`" /> -->
  <a-spin :indicator="customIndicator" />
</template>

<script>
//library
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import mainTheme from "@/assets/themes/mainTheme";
import { h } from "vue";
import { LoadingOutlined } from "@ant-design/icons-vue";

export default {
  name: "ClipLoaderVue",
  components: { ClipLoader },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "white",
    },
    size: {
      type: [String, Number],
      default: "30",
    },
  },
  data() {
    return {
      theme: mainTheme,
      customIndicator: null,
    };
  },
  mounted() {
    // Define the custom half-circle loader during component creation

    this.customIndicator = h(LoadingOutlined, {
      style: {
        fontSize: `${this.size ?? "30px"}px`,
        color: this.themeColors(),
      },
      spin: true,
    });
  },
  methods: {
    themeColors() {
      const theme = this.theme;

      const splitClass = this.color && this.color?.trim().split("-");
      const primary = splitClass?.[0];
      const secondary = splitClass?.[1];
      if (!primary) {
        return "white";
      }

      if (splitClass?.[1]) {
        return theme?.[primary]?.[secondary] ?? "white";
      } else {
        return primary;
      }
    },
  },
};
</script>

<style></style>
